/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard PRO React components
import MasterCard from "examples/Cards/MasterCard";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

// Billing page components
import PageLayout from "examples/LayoutContainers/PageLayout";

import Balance from "./components/Balance";
import Invoices from "./components/Invoices";
import BillingInformation from "./components/BillingInformation";
import Transactions from "./components/Transactions";
import { useEffect, useState } from "react";
import { useAgencyInfo } from "context/agency";
import { useAgencyChargeLogs } from "queries/agency";
function Billing() {
  const [logs, setlogs] = useState([]);
  const [credits, setcredits] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;
  const [agency] = useAgencyInfo();

  const { data, isFetching } = useAgencyChargeLogs(agency?._id, page, limit);

  // Pages accumulate into `logs`/`credits` (infinite-scroll style) the same
  // way the old manual fetch did - page 1 replaces, later pages append.
  useEffect(() => {
    if (!data) return;
    setlogs((prev) => (page === 1 ? data.data : [...prev, ...data.data]));
    setcredits((prev) => (page === 1 ? data.credits : [...prev, ...data.credits]));
    setTotalPages(Math.max(data.totalDebitPages, data.totalCreditPages, 1));
  }, [data]);

  const loadingMore = isFetching && page > 1;

  const loadMore = () => {
    if (!loadingMore && page < totalPages) {
      setPage((p) => p + 1);
    }
  };
  return (
    <PageLayout stickyNavbar>
      <SoftBox mt={4}>
        <SoftBox mb={3}>
          <Grid container spacing={0}>
            <Grid item xs={12} md={12}>
              <Balance />
            </Grid>
            <Grid item xs={12} md={12}>
           
                <Transactions
                  logs={logs}
                  creditslog={credits}
                  hasMore={page < totalPages}
                  loadingMore={loadingMore}
                  onLoadMore={loadMore}
                />
             
            </Grid>
          </Grid>
        </SoftBox>
      </SoftBox>
    </PageLayout>
  );
}

export default Billing;
